import React,{useContext, useState} from "react";
import "./myaccount.scss";
// import LoginInformation from "./LoginInformation";
import { NavLink, Outlet } from "react-router-dom";
import { MyAccountContext } from "../../App";

const Myaccount = () => {
  const [selectedTab, setSelectedTab] = useState("logininformation");
  const { grantedRoles = [] } = useContext(MyAccountContext) || {};
  const isPractice = grantedRoles.includes("ROLE_PRACTICE");
  return (
    <div className="myaccount-settings">
      <div className="container-fluid main-container main-wrapper">
        <div className="sidebar-container sidebar-container-provider">
          <div className="account-settings-sidebar">
            <div className="sidebar-return">
              {isPractice ? 
              <NavLink to="/my-practice">
                <i className="bi bi-chevron-left"></i>
                <span>Return to Dashboard</span>
              </NavLink>
              :
              
              <NavLink to="/Dashboard">
                <i className="bi bi-chevron-left"></i>
                <span>Return to Dashboard</span>
                </NavLink>
            }
            </div>
            <ul className="sidebar-settings-list">
              <h3 className="settings-list-header">My Account</h3>
              <li 
            //   className="settings-list-item" 
              className={`settings-list-item ${selectedTab === "logininformation" && "selected"}`}
              onClick={() => {
                setSelectedTab("logininformation");
              }}>
                <NavLink to="/account-settings/logininformation">
                  Login Information
                </NavLink>
              </li>
              <li 
            //   className="settings-list-item"
              className={`settings-list-item ${selectedTab === "changepassword" && "selected"}`}
              onClick={() => {
                setSelectedTab("changepassword");
              }}>
                <NavLink to="/account-settings/changepassword">
                  Change Password
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
        <div className="account-setting-main">
          <div className="Myaccount-content">
            <div className="display-flex col-md-12">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Myaccount;
